import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Divider, Grid, Link } from '@mui/material';
import { ProposalStatus, DealStatus } from '../../../../utils/enums'
import { format } from 'date-fns';

const FullDetails = ({ data }) => {
    return (
        <Accordion elevation={0} sx={{ borderRadius: '4px', '&:before': { height: '0px' } }}>
            <AccordionSummary
                expandIcon={<ArrowDropDownIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{ margin: 0 }}>

                <h4>Details</h4>

            </AccordionSummary>
            <AccordionDetails
                sx={{ marginTop: '-17px' }}>
                <Divider />
                <Typography variant="h6" sx={{ marginBottom: 1, marginTop: 1 }}>Proposal Information</Typography>
                <Grid container spacing={2} sx={{ marginLeft: 2, marginRight: 2 }}>
                    {/* Left Column */}
                    <Grid item xs={6}>

                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Topic</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.topic || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Duration</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.duration || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Language</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.language || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Location</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.location || '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Proposal Status</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.proposalStatus != null ? ProposalStatus[data.proposalStatus]?.label : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Deal Status</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.dealStatus != null ? DealStatus[data.dealStatus]?.label : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Modified By</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.updatedBy || '—'}<br />{data?.updatedAt ? format(new Date(data.updatedAt), 'MMMM do yyyy, h:mm:ss a') : '—'}</Typography></Grid>
                        </Grid>
                    </Grid>

                    {/* Right Column */}
                    <Grid item xs={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={4}><Typography>Amount</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.amount ? `$ ${data.amount}` : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Deadline</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.deadline ? format(new Date(data.deadline), 'MMMM do yyyy') : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Date</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.date ? format(new Date(data.date), 'MMMM do yyyy') : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Lead</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.leadId ? <Link to={`${'/leads'}/${data?.leadId}`}>{data?.lead ? `${data.lead.firstName || ''} ${data.lead.lastName || ''}`.trim() : (data?.leadName || 'Lead')}</Link> : '—'}</Typography></Grid>
                            {data?.accountId !== 0 && (
                                <>
                                    <Grid item xs={4}><Typography>Account</Typography></Grid>
                                    <Grid item xs={8}><Typography>{data?.accountId ? <Link to={`${'/accounts'}/${data?.accountId}`}>{data?.accountName || 'Account'}</Link> : '—'}</Typography></Grid>
                                </>
                            )}
                            <Grid item xs={4}><Typography>Deal</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.dealId ? <Link to={`${'/deals'}/${data?.dealId}`}>{data?.dealName || 'Deal'}</Link> : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Assign To</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.assignTo && Array.isArray(data.assignTo) ? data.assignTo.join(', ') : '—'}</Typography></Grid>
                            <Grid item xs={4}><Typography>Created By</Typography></Grid>
                            <Grid item xs={8}><Typography>{data?.createdBy || '—'}<br />{data?.createdAt ? format(new Date(data.createdAt), 'MMMM do yyyy, h:mm:ss a') : '—'}</Typography></Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}

export default FullDetails;

